import { SvgIcon, SvgIconProps } from '@mui/material'

const IconError = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 14 14" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.55556 7C1.55556 3.99312 3.99312 1.55556 7 1.55556C10.0069 1.55556 12.4444 3.99312 12.4444 7C12.4444 10.0069 10.0069 12.4444 7 12.4444C3.99312 12.4444 1.55556 10.0069 1.55556 7ZM7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM9.50545 9.50543C9.20171 9.80917 8.70925 9.80917 8.40551 9.50543L7.00003 8.09994L5.59454 9.50543C5.2908 9.80917 4.79834 9.80917 4.4946 9.50543C4.19086 9.20169 4.19086 8.70923 4.4946 8.40548L5.90008 7L4.4946 5.59452C4.19086 5.29077 4.19086 4.79831 4.4946 4.49457C4.79834 4.19083 5.2908 4.19083 5.59454 4.49457L7.00003 5.90006L8.40551 4.49457C8.70925 4.19083 9.20171 4.19083 9.50545 4.49457C9.8092 4.79831 9.8092 5.29078 9.50545 5.59452L8.09997 7L9.50545 8.40548C9.8092 8.70923 9.80919 9.20169 9.50545 9.50543Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default IconError
